import { matrixMinMaxZ } from 'ml-spectra-processing';
import { getFactorNumber } from './getFactorNumber';
export function getBestFactorMatrix(matrix, options = {}) {
    const { maxValue, factor, minMax } = options;
    if (factor !== undefined) {
        return factor;
    }
    // is there non integer number ?
    let onlyInteger = true;
    for (let row of matrix) {
        for (let y of row) {
            if (Math.round(y) !== y) {
                onlyInteger = false;
                break;
            }
        }
    }
    if (onlyInteger) {
        return 1;
    }
    // we need to rescale the values
    // need to find the max and min values
    const extremeValues = minMax || matrixMinMaxZ(matrix);
    return getFactorNumber(extremeValues, maxValue);
}
//# sourceMappingURL=getBestFactorMatrix.js.map